<div class="tab-content" [class.loading]="!isContentReady" *ngIf="canViewIdentityProviders">
  <i *ngIf="!isContentReady" class="fa-solid fa-spinner fa-spin tab-loading-spinner"></i>
  <ng-container *ngIf="isContentReady">
    <p class="double-margin-bottom">
      View and manage any SAML Identity Providers you have connected to your Arpio account.
    </p>
    <ng-container *ngIf="accountService.listIdentityProviders(false).length > 0; else noIdps">
      <table class="arpio-table">
        <tr>
          <th class="nowrap strong-text type-column">Type</th>
          <th class="nowrap strong-text name-column">Name</th>
          <th class="nowrap strong-text actions-column" *ngIf="canManageIdentityProviders">Actions</th>
        </tr>
        <tr *ngFor="let idp of accountService.listIdentityProviders(false)">
          <td class="nowrap">{{ typeDisplay(idp.type) }}</td>
          <td class="nowrap">{{ idp.name }}</td>
          <td class="actions-column" *ngIf="canManageIdentityProviders">
            <ng-container>
              <button type="button" class="icon" title="Update" (click)="openEditIdpDialog(idp)">
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
              <button type="button" class="icon" title="Delete" (click)="openDeleteConfirmModal(idp)">
                <i class="fa-regular fa-trash-can margin-left"></i>
              </button>
              <a
                *ngIf="idp.type === 'msEntra' && !idp.config.consented"
                (click)="startMsEntraIdpAppConsentFlow(idp)"
                class="half-margin-left"
                >Grant Consent</a
              >
            </ng-container>
          </td>
        </tr>
      </table>
    </ng-container>
    <ng-template #noIdps>
      <div>No Identity Providers have been set up yet.</div>
    </ng-template>
    <ng-container>
      <button
        type="button"
        *ngIf="accountService.ssoEnabled() && canManageIdentityProviders"
        id="add-saml-idp-button"
        class="margin-top arpio-button"
        (click)="openAddSamlIdpDialog()"
      >
        Add SAML Identity Provider
      </button>
      <button
        type="button"
        *ngIf="accountService.azureEnabled() && canManageIdentityProviders"
        id="add-entra-dir-button"
        class="margin-top margin-left arpio-button"
        (click)="openAddMsEntraIdpDialog()"
      >
        Add Microsoft Entra Directory
      </button>
    </ng-container>

    <!-- Unified IDP Modal -->
    <app-idp-modal
      #idpModal
      [accountId]="accountService.accountId"
      (save)="onIdpModalSave($event)"
      (cancel)="onIdpModalCancel()"
    ></app-idp-modal>

    <!-- Delete IDP Modal -->
    <modal-dialog #deleteIdpDialog [dialogTemplate]="confirmDeleteDialog"></modal-dialog>
    <ng-template #confirmDeleteDialog>
      <confirm-action-dialog
        name="&quot;{{ toDelete.name }}&quot;"
        [error]="deleteIdpDialog.error"
        (onCancel)="dismissDeleteConfirmModal()"
        (onAction)="deleteIdp(toDelete.identityProviderId)"
      >
        <div class="error margin-top">
          Note: Deleting this identity provider will revoke access for all users who authenticate with it.
        </div>
      </confirm-action-dialog>
    </ng-template>
  </ng-container>
</div>
